module.exports = __webpack_public_path__ + "img/symbol_7.716259a7.png";